import { geoData } from '@fs/zion-config'
import { useQueryParams } from '@fs/zion-router'
import { useVisibilityOverride } from '../../frameworks/VisibilityOverride/VisibilityOverride'

export default function useCountry() {
  const { query } = useQueryParams()
  const { visibilityOverride } = useVisibilityOverride()
  if (query.qa_country) {
    return query.qa_country.toUpperCase()
  }
  if (visibilityOverride.countryCode) {
    return visibilityOverride.countryCode.toUpperCase()
  }
  return geoData.country
}
